module.exports = __webpack_public_path__ + "static/media/background_6.37a64edd.jpg";